import React from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import classNames from "classnames";

import AdventistContainer from "@/shared/components/AdventistContainer/AdventistContainer";
import Container from "@/components/Container/Container";
import VersionView from "@/components/VersionView/VersionView";
import { NEXT_URLS } from "../../utils/routes/routes.constants";
import { usePagePropsContext } from "@/contexts/pageProps";
import IconView from "@/shared/components/IconView/IconView";
import { idCategoryRPRAC } from "@/utils/landing/landing.constants";
import EgwWebFont from "../../../assets/EgwWebFont";

import styles from "./footer.module.scss";
import { makeUrlImgASILogo } from "@/shared/utils/url/url";

const Footer = ({ className }) => {
  const {
    isLanding,
    isBigLanding,
    landingBookViewConfig,
    landingConfigBooksSet,
    landingIdBooksSet,
  } = usePagePropsContext();
  const year = new Date().getFullYear().toString();
  const copyrightText = `Copyright, &copy; ${year}. `;
  const ellenCopyright = "Ellen G. White&reg; Estate, Inc.";
  const isRPRACSet = landingIdBooksSet === idCategoryRPRAC;
  const withAdventistContainerInFooter =
    landingBookViewConfig?.withAdventistContainerInFooter ||
    landingConfigBooksSet?.withAdventistContainerInFooter;

  return (
    <footer
      className={classNames(styles["footer"], className, {
        [styles["big-landing-footer"]]: isBigLanding,
        [styles["asi-footer"]]: isRPRACSet,
      })}>
      <Container className={styles["footer-container"]}>
        <div className={styles["footer-copyright"]}>
          <div className={styles["footer-logo"]}>
            <IconView icon={EgwWebFont.logo} />
          </div>
          <span className={styles["footer-logo-small"]}>&reg;</span>
        </div>
        <div className={styles["footer-logo-text"]}>
          <Link
            href={NEXT_URLS.copirightNotice}
            passHref
            dangerouslySetInnerHTML={{ __html: copyrightText }}></Link>
          <a
            href="https://whiteestate.org/"
            dangerouslySetInnerHTML={{ __html: ellenCopyright }}
            target="_blank"
            rel="noopener noreferrer"
          />
          <br />
          <a
            href="https://www.google.com/maps/place/Ellen+G+White+Estate,+Inc./@39.061175,-76.9679917,17z/data=!3m1!4b1!4m5!3m4!1s0x89b7c51fc029a6a7:0x8214b4d757510e16!8m2!3d39.061175!4d-76.965803"
            target="_blank"
            rel="noopener noreferrer">
            12501 Old Columbia Pike, Silver Spring, MD 20904, USA | Ph# 1.301.680.6540
          </a>
          {!isLanding && (
            <p>
              <VersionView link />
            </p>
          )}
        </div>
      </Container>

      {withAdventistContainerInFooter && !isRPRACSet && (
        <AdventistContainer className={styles["footer-adventist"]} />
      )}
      {withAdventistContainerInFooter && isRPRACSet && (
        <AdventistContainer
          className={styles["footer-adventist"]}
          link="asiministries.org"
          hideLinkLabel
          iconSrc={makeUrlImgASILogo()}
        />
      )}
    </footer>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;
